import React from "react"
import ContentLoader from "react-content-loader"

export default function CommentsLoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 400" rtl={true}>
      <circle cx="20" cy="26" r="20"/>
      <rect x="50" y="10" rx="5" ry="5" width="100" height="12"/>
      <rect x="50" y="28" rx="5" ry="5" width="320" height="16"/>

      <circle cx="20" cy="90" r="20"/>
      <rect x="50" y="72" rx="5" ry="5" width="100" height="12"/>
      <rect x="50" y="90" rx="5" ry="5" width="320" height="16"/>

      <circle cx="20" cy="150" r="20"/>
      <rect x="50" y="134" rx="5" ry="5" width="100" height="12"/>
      <rect x="50" y="152" rx="5" ry="5" width="320" height="16"/>

      <circle cx="20" cy="210" r="20"/>
      <rect x="50" y="194" rx="5" ry="5" width="100" height="12"/>
      <rect x="50" y="212" rx="5" ry="5" width="320" height="16"/>

      <circle cx="20" cy="270" r="20"/>
      <rect x="50" y="254" rx="5" ry="5" width="100" height="12"/>
      <rect x="50" y="272" rx="5" ry="5" width="320" height="16"/>
    </ContentLoader>
  )
}
